"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgFolderOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M4 22c-2 0-2-2-2-2V4c0-2 2-2 2-2h4.706c.294 0 .47.118.559.177L12 4h8c2 0 2 2 2 2v14s0 2-2 2H4zm0-2h16V6h-8c-.053 0-.205-.08-.414-.208C10.75 5.281 9 4 9 4H4v16z' }))); };
exports.default = SvgFolderOutline;
//# sourceMappingURL=FolderOutline.js.map